export default __webpack_public_path__ + "static/qawhat-1-2aa192fc6e8c309dbfe697d9c7b1c54e.png";